import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import {useTranslation, withTranslation} from "react-i18next";
import {getCart} from "../../../../services/Cart/reducer";
import {getStoreConfig} from "../../../../services/Store/reducer";
import StoreUtils from "../../../../services/Store/StoreUtils";
import CartButtonInfoComponent from "./CartButtonInfoComponent";
import {getSession} from "../../../../services/Session/reducer";
import {getFreeDeliveryPrice} from "../../../../utils/cart";
import CartButtonWithDeliveryInfo from "./CartButtonWithDeliveryInfo";
import Money from "../../../Common/Money";
import {ReactComponent as BasketIco} from "../../../../../images/icons/basket.svg";
import ResponsiveComponent from "../../../Common/ResponsiveComponent";

interface OwnProps {
    goToCart: () => void
    menuId: number | undefined;
    useOutsideCart?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartButtonComponent = (props: Props) => {
    const cart = props.cart;
    const {t} = useTranslation();
    const disabled = cart.pending || cart.id == undefined || cart.items.length === 0 || StoreUtils.isPaused(props.config);
    const loading = cart.pending;
    const freeDeliveryPrice = getFreeDeliveryPrice(props.session);
    const isCartButtonWithDeliveryInfoVisible = props.cart.type === "DELIVERY" &&
        props.session.in_delivery_area && props.session.full_address && freeDeliveryPrice !== undefined
        && !isNaN(freeDeliveryPrice);

    const handleOnClick = () => {
        props.goToCart();
    }

    const getTitle = () => {
        let title = t("modules.cart.action.go_to_order.title");

        if (cart.total?.amount > 0) {
            title += " • ";
        }

        return title;
    }

    const renderButtonDiv = (small?: boolean) => {
        if (small) {
            return (
                <>
                    <BasketIco className="basket-ico"/>
                    <Money value={cart.total}/>
                </>
            )
        }

        return (
            <>
                {getTitle()}
                {cart.total?.amount > 0 && <Money value={cart.total}/>}
            </>
        )
    }

    return (
        <>
            {props.useOutsideCart !== true &&
                <ResponsiveComponent small={<CartButtonInfoComponent menuId={props.menuId}/>} large={<></>}/>}
            {isCartButtonWithDeliveryInfoVisible && props.useOutsideCart !== true ? (
                <CartButtonWithDeliveryInfo disabled={disabled} loading={loading} handleOnClick={handleOnClick}
                                            cart={cart} session={props.session}/>
            ) : (
                <button onClick={handleOnClick}
                        className={"btn-spinner btn btn-primary btn-submit" + (loading ? ' loading' : '')}
                        disabled={disabled}>
                    <span className="left spinner-border spinner-border-sm"/>
                    <div className="d-flex align-items-center justify-content-center">
                        <ResponsiveComponent small={renderButtonDiv(!props.useOutsideCart)} large={renderButtonDiv()}/>
                    </div>
                </button>
            )}
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartButtonComponent));